// extracted by mini-css-extract-plugin
export var hamburger = "Hamburger-module--hamburger--46a86";
export var isFixed = "Hamburger-module--isFixed--09749";